<template>
    <div class="o-care care">
        <OContentHeader
            icon="care"
            :title="$t('ui.care-category')"
            :sub-title="$t('ui.care-category.description')"
        />
        <OTiles
            :items-per-block="12"
            :items="getSortedItemsByLetters"
            @tileClick="redirectUser"
        >
            <template #default="{ button }">
                <OTTile
                    :item="getDenormalisedObjectById(button.id)"
                />
            </template>
        </OTiles>
        <OSortingPanel
            v-model="sortingValue"
            :defined-buttons="definedButtons"
            :label="$t('ui.show')"
        />
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
    
import OTiles from '../../organisms/o-tiles/o-tiles';
import OTTile from '../../unique-organisms/o-t-tile/o-t-tile';
import OSortingPanel from '../../organisms/o-sorting-panel/o-sorting-panel';
import OContentHeader from '../../organisms/o-content-header/o-content-header';

import sortButtons from "../../../utils/mixins/sort-buttons";
import sortByLetters from "../../../utils/mixins/sort-by-letters";

import { GUIDE_SCREEN } from '../../../utils/constants/pages';

export default {
    name: 'OCare',
    mixins: [
        sortByLetters,
        sortButtons
    ],
    components: {
        OTiles,
        OTTile,
        OSortingPanel,
        OContentHeader
    },
    computed: {
        ...mapGetters([
            'getTenantsAZ',
            'getDenormalisedObjectById'
        ]),
        getItems() {
            return this.getTenantsAZ;
        }
    },
    methods: {
        redirectUser(data) {
            const params = {
                name: GUIDE_SCREEN,
                params: {
                    type: 'care',
                    id: data.id
                }
            };
            this.$router.push(params);
        }
    }
}
</script>

<style lang="scss">
@import "o-care";
</style>
